// shared css require needs to come first so component css can override shared css without needing !important
require('@alltrails/shared/sharedCss.css');

import { startBugsnag } from 'utils/bugsnag';
import MapWidget from '../application/javascripts/react_components/maps/MapWidget';
import OriginalLanguageButton from '../components/shared/OriginalLanguageButton';
import WaypointPopup from '../components/shared/MapPopups/WaypointPopup';
import PhotoPopup from '../components/shared/MapPopups/PhotoPopup';
import TrailHoverCard from '../components/cards/TrailHoverCard';
import ActivityHoverCard from '../components/cards/ActivityHoverCard';
import GlobalActions from '../components/GlobalActions';

const ReactRailsUJS = require('react_ujs');

startBugsnag();

const context = {
  MapWidget,
  OriginalLanguageButton,
  WaypointPopup,
  PhotoPopup,
  TrailHoverCard,
  ActivityHoverCard,
  GlobalActions
};
ReactRailsUJS.getConstructor = className => {
  return context[className];
};
